import React from 'react';
import styles from './style.module.css';
import Typography from '../../components/Typography/Typography';
import { AboutHeroImage } from '../../assets/webp';
import { ChevronDown } from '../../assets/svgs';
import AnimatedCard from '../../components/AnimatedCard';
import AnimatedButton from '../../components/AnimatedButton';

export const AboutHero: React.FC = () => {
  return (
    <div className={styles.aboutHero}>
    <section className={styles.aboutHeroContainer}>
      <AnimatedCard
      delay={200}
      hoverEffect={false}
      floatAnimation={true}
      >
      <img
        src={AboutHeroImage}
        alt="Immersive Digital Market Gallery"
        width={1303}
        height={541}
        className={styles.galleryImage}
      />
      </AnimatedCard>

      <div className={styles.aboutHeader}>
        <Typography
          variant="heading1"
          fontFamily="satoshi"
          weight="bold"
          className={styles.title}
        >
          Immersive Digital Market
          Anywhere, Anytime
        </Typography>
    </div>
        <div className={styles.scrollIconWrapper}>

        <div className={styles.chevronDownContainer}>
          <img
            src={ChevronDown}
            alt="Scroll down"
            className={styles.scrollIcon}
          />
          </div>
          <Typography
            variant='bodyRegular'
            fontFamily='satoshi'
            weight='regular'
            size='base'
          className={styles.scrollText}>
            Scroll down
            </Typography>
        </div>
    </section>
    </div>
  );
};
